import { Injectable } from '@angular/core';
import { Organization } from '../../state/models/organization';
import { AmplitudeService } from './amplitude.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {
  organization: Organization | undefined;
  setByApi: boolean;

  constructor(private amplitudeService: AmplitudeService) {
  }

  setOrganization(organization?: Organization): boolean {
    if (organization) {
      const ho = this.getOrgByType(organization, organization?.parent, 'HEALTH_OPERATOR');
      const hr = this.getOrgByType(organization, organization?.parent, 'HUMAN_RESOURCES');
      const brk = this.getOrgByType(organization, organization?.parent, 'BROKER');
      if (brk) {
        this.amplitudeService.addIdentifyEvent('broker_id', brk?.id.toString());
        this.amplitudeService.addIdentifyEvent('broker_name', brk?.name);
      }

      if (!!organization?.group) {
        this.amplitudeService.addIdentifyEvent('group_id', organization?.group?.id.toString());
      }

      if (ho) {
        this.amplitudeService.addIdentifyEvent('ho_id', ho?.id.toString());
        this.amplitudeService.addIdentifyEvent('ho_name', ho?.name);
      }

      if (hr) {
        this.amplitudeService.addIdentifyEvent('hr_id', hr?.id.toString());
        this.amplitudeService.addIdentifyEvent('hr_name', hr?.name);
      }

      this.organization = organization;
    } else {
      this.organization = DEFAULT_ORGANIZATION;
    }
    return true;
  }

  getOrganization(): Organization {
    return this.organization;
  }


  getOrgByType(organization: Organization, parent: Organization, type: Organization['type']) {
    if (organization.type === type) {
      return organization;
    }
    if (parent?.type === type) {
      return parent;
    }
    return undefined;
  }

}

const DEFAULT_ORGANIZATION = {
  nameUrlSafe: 'mar',
  name: 'Mar Saúde',
  logo: 'https://mar-static.s3.us-east-2.amazonaws.com/organization-logo/mar.png',
  favicon: 'https://mar-static.s3.us-east-2.amazonaws.com/organization-favicon/mar.ico'
};
